import classes from './ChatWidget.module.scss'
import { IconExternal } from './icons'
import { ChatExternalLink } from './types'

interface Props {
  links: ChatExternalLink[]
}

/**
 * Kurumsal site bağlantıları (iletişim / hakkımızda / yetkili servis sayfaları ve madde 6'nın
 * altı site listesi). Adresler backend'de sabittir; `chatMappers` ayrıca kendi beyaz listesiyle
 * doğrular — buraya yalnız doğrulanmış adres ulaşır. Portal İÇİ geçişler için `NavigationActions`
 * kullanılır; iki kanal bilinçli olarak ayrıdır.
 */
export default function ExternalLinkCards({ links }: Props) {
  if (links.length === 0) return null

  return (
    <nav className={classes.externalLinks} aria-label='Kurumsal site bağlantıları'>
      {links.map(link => (
        <a
          key={`${link.url}-${link.label}`}
          className={classes.externalLink}
          href={link.url}
          target='_blank'
          rel='noopener noreferrer'
        >
          <span>{link.label}</span>
          <span className={classes.externalLinkIcon} aria-hidden='true'>
            <IconExternal />
          </span>
        </a>
      ))}
    </nav>
  )
}
